import React from "react";
import { Container } from "./styles";
import { Link } from 'react-router-dom';
import { Col, Row } from "react-bootstrap";
import { useUsuarioLogado } from "../../hooks/usuarioLogado";


export function Menu(){
    const { usuario: dadosUsuario } = useUsuarioLogado();
    const cargo = dadosUsuario?.dadoUsuario.cargo?.id || 0
    const codigoUsuario = dadosUsuario?.dadoUsuario.codigo?.toString() || '0'

    const UsuarioId = localStorage.getItem('@Gscon:UsuarioID')
    const ParceiroCor = localStorage.getItem('@Gscon:ParceiroCor')
    const ParceiroImagem = localStorage.getItem('@Gscon:ParceiroImagem')
    const ParceiroContrato = localStorage.getItem('@Gscon:ParceiroContrato')

    return(
        <Container>
            <strong>Menu</strong>
            <Row>
            <Col>
            <Link to="/Vendas">
            <button>
                Vendas
            </button>
            </Link>
            </Col>
            <Col>
            <Link to="/consultaContrato">
            <button style={{background:ParceiroCor||""}} type="button">
                Consulta contratos
            </button>
            </Link>
            </Col>
            </Row>
            <Row>
            <Col>
            <Link to="/Simulacao">
            <button style={{background:ParceiroCor||""}} type="button">
                Simulação
            </button>
            </Link>
            </Col>
            <Col>
            <Link to="/contemplacoes">
            <button style={{background:ParceiroCor||""}} type="button">
                Resultado Assembleias
            </button>
            </Link>
            </Col>
            </Row>
            
            
            

            

            {cargo===3?<>
                
                <strong style={{marginTop: 20, color:ParceiroCor||""}}>BI</strong>
                <Row>
                <Col>
                <Link to="/BiVendas">
                <button style={{background:ParceiroCor||""}} type="button">
                    Vendas
                </button>
                </Link>
                </Col>
                <Col>
                <Link to="/BiContemplacao">
                <button style={{background:ParceiroCor||""}} type="button">
                    Contemplação
                </button>
                </Link>
                </Col>
                </Row>
                <Row>
                <Col>
                
                <Link to="/BiInadimplencia">
                <button style={{background:ParceiroCor||""}} type="button">
                    Inadimplência
                </button>
                </Link>
                </Col>
                </Row>            
            </>:<></>}
            {codigoUsuario==='002366'?<>
                <strong style={{marginTop: 20, color:ParceiroCor||""}}>BI</strong>
                <Link to="/BiVendas2366">
                <button style={{background:ParceiroCor||""}} type="button">
                    Vendas
                </button>
                </Link>
                <Link to="/BiInadimplencia2366">
                <button style={{background:ParceiroCor||""}} type="button">
                Inadimplência
                </button>
                </Link>

            
            </>:<></>}
            {UsuarioId==='583'?<>
                
                <strong style={{marginTop: 20, color:ParceiroCor||""}}>BI</strong>
                <Row>
                <Col>
                <Link to="/BiVendas">
                <button style={{background:ParceiroCor||""}} type="button">
                    Vendas
                </button>
                </Link>
                </Col>
                <Col>
                <Link to="/BiContemplacao">
                <button style={{background:ParceiroCor||""}} type="button">
                    Contemplação
                </button>
                </Link>
                </Col>
                </Row>
                <Row>
                <Col>
                
                <Link to="/BiInadimplencia">
                <button style={{background:ParceiroCor||""}} type="button">
                    Inadimplência
                </button>
                </Link>
                </Col>
                </Row>            
            </>:<></>}

           
        </Container>
    );
}